import { COUPON_DISPLAY_NAME_MAX_LENGTH } from '../../config';
import { CouponInCampain } from '../../types/coupon';

export const getCouponDisplayName = (coupon: CouponInCampain): string => {
  if (coupon.displayName) {
    return coupon.displayName;
  }

  if (!coupon.name) {
    return 'Unknown coupon';
  }

  if (coupon.name.length > COUPON_DISPLAY_NAME_MAX_LENGTH) {
    return `${coupon.name.substring(0, 40)}...`;
  }

  return coupon.name;
};
